export const renderAverageRating = (averageRating: number | null) =>
  averageRating !== null ? averageRating.toFixed(1) : 'N/A';
